<template>
    <div>
        {{typeof valid_time.d !=='string'? valid_time.d + ':' : ''}}{{valid_time.h}}:{{valid_time.m}}:{{valid_time.s}}
    </div>
</template>

<script>

    export default {
        name: "timer",
        computed: {
            valid_time(){
                return this.$store.getters.valid_time;
            }
        },
    }
</script>

<style scoped>

</style>